<template>
    <div class="sales_container">
        <div class="filter_container">
            <div class="filter_top">
                <div class="filter_title">
                    <div class="filter_title_top">
                        智能汽车销量数据
                    </div>
                    <div class="filter_title_bot">
                        SALES RANKING
                    </div>
                </div>
                <div class="filter_line"></div>
                <div class="rank_desc">
                    {{analysis_data.current_date && analysis_data.current_date.slice(0,4)}}年{{analysis_data.current_date && analysis_data.current_date.slice(4)}}月，智能网联乘用车销量{{analysis_data.current && analysis_data.current.total_smart_sales}}辆，渗透率{{analysis_data.current && analysis_data.current.total_percent}}%，
                    其中新能源汽车智能化渗透率{{analysis_data.current && analysis_data.current.energy_percent}}%，燃油汽车智能化渗透率{{analysis_data.current && analysis_data.current.oil_percent}}%；<br>
                    {{analysis_data.last_date && analysis_data.last_date.slice(0,4)+'年'+analysis_data.last_date.slice(4)+'月'}}～{{analysis_data.current_date && analysis_data.current_date.slice(0,4)+'年'+analysis_data.current_date.slice(4)+'月'}}，智能网联乘用车累计销售{{analysis_data.total && analysis_data.total.total_smart_sales}}辆，累计渗透率{{analysis_data.total && analysis_data.total.total_percent}}%，其中新能源汽车智能化累计渗透率{{analysis_data.total && analysis_data.total.energy_percent}}%，燃油汽车智能化累计渗透率{{analysis_data.total && analysis_data.total.oil_percent}}%
                </div>
            </div>
             <div class="navs">
                <div :class="['nav',rank_type == 'serie'?'active':'']" @click="changeRank('serie')">
                    <span class="icon icon_car"></span>
                    <span>车系榜</span>
                </div>
                <div :class="['nav',rank_type == 'province'?'active':'']" @click="changeRank('province')">
                    <span class="icon icon_local"></span>
                    <span>地区榜</span>
                </div>
                <div :class="['nav',rank_type == 'brand'?'active':'']" @click="changeRank('brand')">
                    <span class="icon icon_brand"></span>
                    <span>品牌榜</span>
                </div>
                <div :class="['nav',rank_type == 'enterprise'?'active':'']" @click="changeRank('enterprise')">
                    <span class="icon icon_vendor"></span>
                    <span>厂商榜</span>
                </div>
            </div>
            <div class="filter_bot">
                <div class="filter_item filter_item_energy">
                    <div class="filter_val">
                        {{energy_obj.name}}
                    </div>
                    <div class="filter_options_box">
                        <div class="filter_options">
                            <div class="filter_option" :class="item.name == energy_obj.name?'act':''" v-for="(item,ind) in energy_list" :key="ind" @click="filterChangeFn(item,'energy')">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="filter_item filter_item_province" v-if="rank_type != 'province'">
                    <div class="filter_val">
                        {{province_obj.name}}
                    </div>
                    <div class="filter_options_box">
                        <div class="filter_options">
                            <div class="filter_option" :class="item.name == province_obj.name?'act':''" v-for="(item,ind) in province_list" :key="ind" @click="filterChangeFn(item,'province')">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="filter_item filter_item_date">
                    <div class="filter_val">
                        {{date_obj.name}}
                    </div>
                    <div class="filter_options_box">
                        <div class="filter_options">
                            <div class="filter_option" :class="item.name == date_obj.name?'act':''" v-for="(item,ind) in date_list" :key="ind" @click="filterChangeFn(item,'date')">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="filter_item filter_item_price" v-if="energy_obj.val == 2 && rank_type =='serie'">
                    <div class="filter_val">
                        {{price_obj.name}}
                    </div>
                    <div class="filter_options_box">
                        <div class="filter_options">
                            <div class="filter_option" :class="item.name == price_obj.name?'act':''" v-for="(item,ind) in price_list" :key="ind" @click="filterChangeFn(item,'price')">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="filter_item">
                    <select class="etype" v-model="etype" @change="filterChange('etype')">
                        <template v-for="(item,ind) in energy_list" :key="ind">
                            <option :value="item.val">
                                {{item.name}}
                            </option>
                        </template>
                    </select>
                </div>
                <div class="filter_item" v-if="rank_type != 'province'">
                    <select class="province" v-model="province" @change="filterChange('province')">
                        <template v-for="(item,ind) in province_list" :key="ind">
                            <option :value="item.val">
                                {{item.name}}
                            </option>
                        </template>
                    </select>
                </div>
                <div class="filter_item">
                    <select class="date" v-model="date" @change="filterChange('date')">
                        <template v-for="(item,ind) in date_list" :key="ind">
                            <option :value="item.val">
                                {{item.name}}
                            </option>
                        </template>
                    </select>
                </div>
                <div class="filter_item" v-if="etype == 2">
                    <select class="price" v-model="price" @change="filterChange('price')">
                        <template v-for="(item,ind) in price_list" :key="ind">
                            <option :value="item.val">
                                {{item.name}}
                            </option>
                        </template>
                    </select>
                </div> -->
                <div class="top_text"><span style="color:#D94B4B">*</span>数据源于车辆上牌信息，每月25号左右更新</div>
            </div>
        </div>
        <div class="content">
            <div class="my_charts" ref="myChart" v-loading="chart_loading"></div>
            <div class="rank_list">
                <table class="rank_table">
                    <tr class="rank_table_tit">
                        <td>排名</td>
                        <td v-if="rank_type == 'enterprise'">厂商</td>
                        <td v-if="rank_type == 'brand'">品牌</td>
                        <td v-if="rank_type == 'serie'">车系</td>
                        <td v-if="rank_type == 'province'">地区</td>
                        <td>智能车销量</td>
                        <td>{{energy_obj.val==1?'传统能源':'新能源'}}总销量</td>
                        <td v-if="energy_obj.val == 2 && rank_type=='serie'">价格</td>
                        <td>排名动态</td>
                        <td>趋势</td>
                    </tr>
                        <template v-for="(item,ind) in rank_list" :key="ind">
                        <rankListItem
                            :item_info="{
                                rank_type,
                                energy_obj,
                                data:item,
                                ind:ind*1+1
                            }"
                            @toDetail="toDetail"
                        />
                    </template>
                </table>
                <div class="loading_text" v-if="loading">正在加载中···</div>
                <div class="loading_text" v-if="!loading && total_page>=page">没有更多了~</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    salesRank,
    salesTotal,
    salesAnalysis,
    salesAnalysisByDate
} from '@/api';
import rankListItem from "@/components/sales/Item.vue";
const echarts = require('echarts');
let myChart = null;
export default {
    name:"sales_rank",
    components:{
        rankListItem
    },
    data:() => {
        return {
            rank_type:'serie',  // 车系 serie 地区 province 品牌 brand 厂商 enterprise
            etype:"2",     // 1。燃油   2.电动
            province:"",
            date:'202201',

            energy_obj:{
                name:'智能新能源',
                val:'2'
            },
            energy_list:[
                {
                    name:"智能新能源",
                    val:"2"
                },
                {
                    name:"智能燃油",
                    val:"1"
                }

            ],
            province_obj:{
                name:'全国',
                val:''
            },
            province_list:[
                {
                    name:"全国",
                    val:""
                },
                {
                    name:"北京",
                    val:"北京"
                },
                {
                    name:"天津",
                    val:"天津"
                },
                {
                    name:"上海",
                    val:"上海"
                },
                {
                    name:"重庆",
                    val:"重庆"
                },
                {
                    name:"河北",
                    val:"河北"
                },
                {
                    name:"山西",
                    val:"山西"
                },
                {
                    name:"辽宁",
                    val:"辽宁"
                },
                {
                    name:"吉林",
                    val:"吉林"
                },
                {
                    name:"黑龙江",
                    val:"黑龙江"
                },
                {
                    name:"江苏",
                    val:"江苏"
                },
                {
                    name:"浙江",
                    val:"浙江"
                },
                {
                    name:"安徽",
                    val:"安徽"
                },
                {
                    name:"福建",
                    val:"福建"
                },
                {
                    name:"江西",
                    val:"江西"
                },
                {
                    name:"山东",
                    val:"山东"
                },
                {
                    name:"河南",
                    val:"河南"
                },
                {
                    name:"湖北",
                    val:"湖北"
                },
                {
                    name:"湖南",
                    val:"湖南"
                },
                {
                    name:"广东",
                    val:"广东"
                },
                {
                    name:"海南",
                    val:"海南"
                },
                {
                    name:"四川",
                    val:"四川"
                },
                {
                    name:"贵州",
                    val:"贵州"
                },
                {
                    name:"云南",
                    val:"云南"
                },
                {
                    name:"陕西",
                    val:"陕西"
                },
                {
                    name:"甘肃",
                    val:"甘肃"
                },
                {
                    name:"青海",
                    val:"青海"
                },
                {
                    name:"台湾",
                    val:"台湾"
                },
                {
                    name:"广西",
                    val:"广西"
                },
                {
                    name:"内蒙古",
                    val:"内蒙古"
                },
                {
                    name:"西藏",
                    val:"西藏"
                },
                {
                    name:"宁夏",
                    val:"宁夏"
                },
                {
                    name:"新疆",
                    val:"新疆"
                },
                {
                    name:"香港",
                    val:"香港"
                },
                {
                    name:"澳门",
                    val:"澳门"
                }
            ],
            date_obj:{
                name:'2022年01月',
                val:'202201'
            },
            date_list:[

            ],
            price:0,
            price_obj:{
                name:'全部价格',
                val:0
            },
            price_list:[
                {
                    name:"全部价格",
                    val:0
                },
                {
                    name:"30万以下",
                    val:1
                },
                {
                    name:"30万以上",
                    val:2
                }
            ],
            page:0,
            total_page:1,
            size:10,
            loading:false,
            rank_list:[],
            analysis_data:{},

            chart_loading:false,
            dis_click:true,

            // myChart:null,
        }
    },
    mounted(){
        const that = this;
        that.getSalesAnalysis();
        window.addEventListener('scroll',function(){
            // if (document.documentElement.clientHeight + document.documentElement.scrollTop > document.body.offsetHeight-400){
            //     if (that.page<that.total_page && that.loading == false){
            //         that.loading = true;
            //         that.getSalesRank();
            //     }
            // }
             if (document.querySelector(".el-main").scrollTop + document.documentElement.clientHeight > document.querySelector(".main_content").offsetHeight){
                if (that.page<that.total_page && that.loading == false){
                    that.loading = true;
                    that.getSalesRank();
                }
            }
        } , true)
    },
    unmounted(){
        myChart = null;
    },
    methods:{
        percentage(num,total){
            return (num/total*100).toFixed(2)
        },
        getSalesAnalysis(){
            const that = this;
            salesAnalysis().then(res => {
                that.analysis_data = res.data;
                that.date_obj = {
                    name:res.data.current_date.slice(0,4)+'年'+res.data.current_date.slice(4)+'月',
                    val:res.data.current_date
                };
                let current_date = res.data.current_date;
                let last_date = res.data.last_date;
                let date_list = [];
                if (current_date.slice(0,4) != last_date.slice(0,4)){
                    let i=last_date.slice(4)*1,j=1;
                    for (i;i<=12;i++){
                        date_list.unshift({
                            name:last_date.slice(0,4)+'年'+(i<10?'0'+i:i)+'月',
                            val:last_date.slice(0,4)+''+(i<10?'0'+i:i)
                        })
                    }
                    for (j;j<=current_date.slice(4)*1;j++){
                        date_list.unshift({
                            name:current_date.slice(0,4)+'年'+(j<10?'0'+j:j)+'月',
                            val:current_date.slice(0,4)+''+(j<10?'0'+j:j)
                        })
                    }
                } else {
                    let i=1;
                    for (i;i<=12;i++){
                        date_list.unshift({
                            name:last_date.slice(0,4)+'年'+(i<10?'0'+i:i)+'月',
                            val:last_date.slice(0,4)+''+(i<10?'0'+i:i)
                        })
                    }
                }
                that.date_list = date_list;
                that.dis_click = false;
                that.getSalesTotal();
                that.getSalesRank(true);
            })
        },
        getSalesTotal(){
            const that = this;
            if(myChart){
                myChart.clear();
            }else{
                myChart = echarts.init(that.$refs.myChart);
            }
            that.chart_loading = true;
            // if (res && res.code && res.data && res.data.length>0){
            //             let xAxis_data = [];
            //             let series_data = [];
            //             res.data.reverse().forEach(item => {
            //                 xAxis_data.push(item.date.slice(2,4)+'年'+item.date.slice(4)+'日');
            //                 series_data.push(item.total_smart_sales);
            //             })
            //             that.chart_loading = false;
            //             that.drawLine(xAxis_data,series_data);
            //         }
            let promise1 = new Promise((resolve,reject)=>{
                salesTotal({
                    etype:that.energy_obj.val,
                    province:that.rank_type == 'province'?null:that.province_obj.val,
                    date:that.date_obj.val,
                    price:that.price_obj.val
                }).then(res => {
                    if(res && res.code && res.data && res.data.length>0){
                        resolve(res.data);
                    }else{
                        reject()
                    }
                }).catch(()=>reject());
            })
            let promise2 = new Promise((resolve,reject)=>{
                salesAnalysisByDate({
                    etype:that.energy_obj.val,
                    province:that.rank_type == 'province'?null:that.province_obj.val,
                    date:that.date_obj.val,
                }).then(res => {
                    if(res && res.code && res.data && res.data.length>0){
                        resolve(res.data);
                    }else{
                        reject()
                    }
                }).catch(()=>reject());
            })

            Promise.all((!this.province_obj.val&&!this.price_obj.val)?[promise1,promise2]:[promise1]).then(data_list=>{
                console.log(data_list);
                    let xAxis_data = [];
                    let series_data = [];
                    let series_data2 = [];
                    data_list[0].reverse().forEach(item => {
                        xAxis_data.push(item.date.slice(2,4)+'年'+item.date.slice(4)+'日');
                        series_data.push(item.total_smart_sales);
                    })
                    if(data_list.length==2){
                        data_list[1].reverse().forEach(item => {
                            series_data2.push(item.total_percent);
                        })
                    }else{
                        series_data2 = null;
                    }
                    
                    that.chart_loading = false;
                    that.drawLine(xAxis_data,series_data,series_data2);
            })
            

        },
        getSalesRank(rerender){
            const that = this;
            that.loading = true;
            if (rerender){
                this.page=0;
                this.total_page=1;
                this.rank_list=[];
            }
            that.page = that.page+1;
            salesRank({
                etype:that.energy_obj.val,
                rank_type:that.rank_type,
                province:that.rank_type == 'province'?null:that.province_obj.val,
                price:that.price_obj.val,
                date:that.date_obj.val,
                page:that.page,
                size:that.size,
            }).then(res => {
                that.loading = false;
                that.rank_list = that.rank_list.concat(res.data.list);
                that.page = res.data.page*1;
                that.size = res.data.size;
                that.total_page= res.data.total_page*1;
            })
        },
        drawLine(xAxis_data,series_data,series_data2){
            let legend_data = series_data2?[
                {
                    name:'销量'
                },
                {
                    name:'渗透率（%）'
                }
            ]:[
                {
                    name:'销量'
                }
            ];
            let yAxis_data = series_data2?[
                {
                    type: "value",
                    minInterval:1,
                    max:(val)=>{
                        return val.max*2
                    },
                    axisLine: { 
                        lineStyle: { 
                            color: "#999", 
                            width: 0.1 
                        }
                    },
                    splitLine:{
                        show:true
                    },
                    axisLabel:{
                        formatter:function(value){
                            return value>9999?(parseInt(value/10000) +' 万'):value;
                        }
                    },
                },
                {
                    type: "value",
                    // min:0,
                    // max:100,
                    axisLine: { 
                        lineStyle: { 
                            color: "#999", 
                            width: 0.1 
                        }
                    },
                    splitNumber:5,
                    splitLine:{
                        show:false
                    },
                    axisLabel:{
                        formatter:function(value){
                            return value+'%';
                        }
                    }
                },
            ]:[
                {
                    type: "value",
                    minInterval:1,
                    axisLine: { 
                        lineStyle: { 
                            color: "#999", 
                            width: 0.1 
                        }
                    },
                    splitLine:{
                        show:true
                    },
                    axisLabel:{
                        formatter:function(value){
                            return value>9999?(parseInt(value/10000) +' 万'):value;
                        }
                    }
                },
            ];
            let series_datas = series_data2?[
                {
                    name: "销量",
                    type: "bar",
                    data: series_data,
                    // smooth: true,
                    itemStyle: {
                        normal: {
                            color: "rgba(31, 188, 191, 1)"
                        }
                    },
                    barWidth:20,
                    yAxisIndex:0,
                    label: {
                        show: true,
                        position:'top'
                    }
                },
                {
                    name: "渗透率（%）",
                    type: "line",
                    data: series_data2,
                    // smooth: true,
                    itemStyle: {
                        normal: {
                            color: "rgba(255, 0, 0, 1)"
                        }
                    },
                    yAxisIndex:1,
                    label: {
                        show: true
                    }
                }
            ]:[
                {
                    name: "销量",
                    type: "bar",
                    data: series_data,
                    // smooth: true,
                    itemStyle: {
                        normal: {
                            color: "rgba(31, 188, 191, 1)"
                        }
                    },
                    barWidth:20,
                    yAxisIndex:0,
                    label: {
                        show: true
                    }
                }
            ];
            console.log(legend_data)
            myChart.setOption({
                legend:{
                    // data:legend_data,
                },
                tooltip: { 
                    trigger: "axis",
                    // formatter: '{b0}:<br />  {a0}: {c0}<br />{a1}: {c1}%'
                },
                grid: {
                    show: true,
                    backgroundColor: "rgba(250, 250, 250, .6)",
                    borderColor: "rgba(255, 255, 255, 1)",
                    left: "2%",
                    right: "0",
                    top:"40",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: xAxis_data,
                    axisLine: {
                        lineStyle:{
                            // color:'#000'
                        }
                    },
                    splitLine: {
                        show:false
                    },
                    axisTick:{
                        show:true,
                        alignWithLabel: true,
                        // lineStyle: {
                        //     color:"rgba(222, 222, 222, 1)",
                        // }
                    },
                    axisLabel:{
                        interval:0
                    },
                    nameTextStyle:{
                        overflow:'break'
                    }
                },
                yAxis: yAxis_data,
                series: series_datas
            });
        },
        filterChangeFn(data,type){
            this[type+'_obj'] = data;
            if(type == 'energy'){
                this.price_obj={
                    name:'全部价格',
                    val:0
                }
            }
            this.getSalesTotal(true);
            this.getSalesRank(true);
        },
        changeRank(type){
            if(type!='serie'){
                this.price_obj={
                    name:'全部价格',
                    val:0
                }
            }
            if(this.dis_click){
                return;
            }
            if (type != this.rank_type){
                this.rank_type=type;
                this.getSalesTotal(true);
                this.getSalesRank(true);
            }
        },
        toDetail(info){
            const that = this;
            let link_info = {
                etype:that.energy_obj.val,
                date_obj:that.date_obj,
                rank_name:info.data.province,
                rank_type:info.rank_type
            }
            if (info.rank_type == "serie"){
                link_info.rank_name = info.data.serie_name;
                link_info.rank_id = info.data.serie_id;
            } else if (info.rank_type == "brand"){
                link_info.rank_name = info.data.brand_name;
            } else if (info.rank_type == "enterprise"){
                link_info.rank_name = info.data.enterprise;
            }
            this.$router.push({
                path:"/service/sales/detail",
                query:{
                    rank_type:info.rank_type,
                    link_info:JSON.stringify(link_info)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.sales_container{
    width: 1224px;
    background: #FFFFFF;
    border-radius: 13px 0 0 0;
    padding: 53px 56px 53px 59px;
}
.filter_container{
    width: 100%;
    .filter_top{
        box-sizing: border-box;
        height: 145px;
        background:#F6F9FD url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/bg_20230213.png) no-repeat;
        background-size: auto 100%;
        display: flex;
        align-items: center;
        padding-left: 189px;
        .filter_title{
            .filter_title_top{
                width: 80px;
                height: 45px;
                font-size: 20px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
            }
            .filter_title_bot{
                margin-top: 7px;
                width: 81px;
                height: 14px;
                font-size: 12px;
                font-weight: bold;
                color: #000000;
                line-height: 14px;
                white-space: nowrap;
                transform: scale(.8);
                margin-left: -6px;
            }
           
        }
        .filter_line{
            width: 1px;
            height: 60px;
            background:#979797;
            margin: 0 41px 0 44px;
        }
        .rank_desc{
            width: 721px;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
        }
        
    }
    .navs{
        display: flex;
        justify-content: space-between;
        background: #F6F9FD;
        .nav{
            width: 276px;
            height: 44px;
            background: #2F2D43;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
            .icon{
                width: 20px;
                height: 20px;
                margin-right: 9px;
                &.icon_car{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/car_a.png) no-repeat center right;
                    background-size: 19px;
                }
                &.icon_local{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/local_a.png) no-repeat center right;
                    background-size: 15px;
                }
                &.icon_brand{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/brand_a.png) no-repeat center right;
                    background-size: 18px;
                }
                &.icon_vendor{
                    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/vendor_a.png) no-repeat center right;
                    background-size: 18px;
                }
            }
            &.active{
                background: #1FBCBF;
            }
        }
    }
    .filter_bot{
        width: 1109px;
        height: 51px;
        background: #F6F9FD;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        padding-left: 20px;
        .filter_item{
            height: 34px;
            width: auto;
            margin-right: 18px;
            position: relative;
            cursor: pointer;
            .filter_val{
                width: 100%;
                height: 100%;
                line-height: 34px;
                font-size: 14px;
                text-align: center;
                color: #151515;
                padding-right:20px;
                background:#fff url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/sanjiao_20230223.png) no-repeat;
                background-size: 11px;
                background-position:calc(100% - 10px);
                // border: solid 1px #E8E8E8;
            }
            .filter_options_box{
                display: none;
                position: absolute;
                top: 34px;
                left: 0;
                padding-top: 10px;
                z-index: 10;
                width: 100%;
            }
            .filter_options{
                width: 100%;
                max-height: 280px;
                overflow-y: auto;
                background: #fff;
                // box-shadow: 0 0 3px 2px #ededed;
                border: solid 1px #ddd;
                .filter_option{
                    font-size: 14px;
                    width: 100%;
                    padding:10px 20px;
                    &.act{
                        color: rgba(31, 188, 191, 1);
                    }
                    &:hover{
                        background: rgba(31, 188, 191, .1);
                        // color: rgba(31, 188, 191, .8);
                    }
                }
            }
            &:hover .filter_options_box{
                display: block;
            }
            &:hover .filter_val{
                border: solid 1px #1FBCBF;
            }
            select{
                height: 100%;
                appearance:none;
                border: none;
                outline: none;
                font-size: 16px;
                text-align: center;
                color: #151515;
                padding-right:20px;
                background:#fff url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/select.png) no-repeat;
                background-size: 11px;
                background-position:calc(100% - 10px);
                &::-ms-expand{
                    display: none;
                }
            }
            &.filter_item_energy{
                width: 180px;
            }
            &.filter_item_province{
                width: 112px;
            }
            &.filter_item_date{
                width: 179px;
            }
            &.filter_item_price{
                width: 120px;
            }
        }
        .top_text{
            margin-right: 15px;
            margin-left: auto;
            font-size: 12px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
        }
    }

}
.my_charts{
    width: 100%;
    height: 300px;
    margin-top: 30px;
}
.rank_list{
    width: 100%;
    margin-top: 20px;
    .rank_table{
        width: 100%;
        border-collapse:collapse;
        td{
            text-align: center;
        }
        .rank_table_tit{
            width:100%;
            height: 51px;
            background: #F6F9FD;
            font-size: 14px;
            color: #333333;
            white-space: nowrap;
        }
    }
}
.loading_text{
    line-height: 80px;
    text-align: center;
    columns: #333;
    font-size: 16px;
}
</style>